import { useState } from "react";
import { Card, Icon } from "@mui/material";

import MDBox from "components/MDBox";
import MDButton from "components/MDButton";

import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

import BasicTable from "ui-components/tables/BasicTable";
import { ListLayout } from "ui-components/Layout";
import { EditButton } from "ui-components/IconButton";
import { Error_ } from "ui-components/Alert";
import { getUOMList } from "services/data.internal.service";
import { TableCard } from "ui-components/Layout";
import { useTeamValue } from "providers/TeamContext";
import { useCustomerValue } from "providers/CustomerContext";

function UOMList() {
  const {permissions, allowAll} = useTeamValue();
  const {customerCode} = useCustomerValue()
  const navigate = useNavigate();
  const [alert, setAlert] = useState(null);
  const [data, setData] = useState([]);
  const onError = (data) => setAlert(<Error_ data={data} onChange={setAlert} />);

  const addPermission = allowAll || (Boolean(permissions["UOM"]) && permissions["UOM"].findIndex(b => b==="new") !== -1);
  const editPermission = allowAll || (Boolean(permissions["UOM"]) && permissions["UOM"].findIndex(b => b==="edit") !== -1);
  const deactivatePermission = allowAll || (Boolean(permissions["UOM"]) && permissions["UOM"].findIndex(b => b==="deactivate") !== -1);

  useQuery({
    queryKey: ["uom-list", {customerCode}],
    queryFn: () => getUOMList(),
    onSuccess: (data) => setData(data.data.data),
    onError,
  });

  const onEdit = (req) => navigate("/setup/uom/edit", { state: req });

  const columns = [
    { header: "UOM Code", accessorKey: "uomid" },
    { header: "Descriptions 1", accessorKey: "descriptions1" },
    { header: "Descriptions 2", accessorKey: "descriptions2" },
    { header: "UOM Type", accessorKey: "uomType" },
    {
      header: "Action",
      accessorKey: "action",
      enableColumnFilter: false,
      cell: ({ row }) => {
        const { uomid } = row.original;
        return (
          <>
            <EditButton title="edit uom" disabled={!editPermission} onClick={() => onEdit({ uomid })} />
          </>
        );
      },
    },
  ];
  return (
    <ListLayout>
      {alert}
      <MDBox my={3}>
        <TableCard>
          <MDBox display="flex" justifyContent="space-between" margin="10px">
            <MDButton variant="gradient" color="info" disabled={!addPermission} onClick={() => navigate("/setup/uom/add")}>
              <Icon>add</Icon>&nbsp;uom
            </MDButton>
          </MDBox>
          <BasicTable columns={columns} data={data} />
        </TableCard>
      </MDBox>
    </ListLayout>
  );
}

export default UOMList;
